import { fromJS } from 'immutable';

export const LOAD_INIT = 'streaming/LOAD_INIT';
export const LOAD_SUCCESS = 'streaming/LOAD_SUCCESS';
export const LOAD_FAIL = 'streaming/LOAD_FAIL';

const ENDPOINT = '/api/streamings';

const initialState = {
  offers: fromJS([])
};

export default function webhotel(state = initialState, { type, payload }) {
  if (type === LOAD_SUCCESS) {
    return {
      ...state,
      offers: fromJS(payload.offers)
    };
  }

  return state;
}

export function getOffers() {
  return {
    types: [LOAD_INIT, LOAD_SUCCESS, LOAD_FAIL],
    promise: client => client.get(`${ENDPOINT}/`)
  };
}

export function isLoaded({ getState }) {
  return getState().streaming.offers.size;
}

export function serialize(state) {
  return state.offers.toJS();
}

export function deserialize(state) {
  if (state === null) {
    return initialState;
  }
  return {
    offers: fromJS(state)
  };
}
